export default __webpack_public_path__ + "static/media/dropdown.56b2670e.svg";